import React from 'react';
import './UrpassAgencies.css';
import { IonItem } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import UrpassSelect from './UrpassSelect';
import { UrPassAgency } from '../../services/types/urpassapitypes';

type UrpassAgenciesProps = {
  agencies: UrPassAgency[] | undefined;
  setAgency: (a: UrPassAgency) => void;
};

export default function UrpassAgencies({
  agencies,
  setAgency,
}: UrpassAgenciesProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 pb-2 ion-text-center">{t('urpassadd.chooseagency')}</h1>
      {agencies && agencies.map((agency: UrPassAgency, index: number) => {
        return (
          <div className="pt-1 pb-2" key={index}>
            <IonItem
              lines="none"
              onClick={() => setAgency(agency)}
              className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
            >
              <UrpassSelect
                title={agency.name}
                subTitle={agency.location}
                icon={agency.id}
              />
            </IonItem>
          </div>
        );
      })}
    </>
  );
}
